import { unixFromDateTime } from "@/core/helpers/unixFromDateTime";

export const getDiffTimeDDHHmm = (
  time: string | Date,
  year: string,
  month: string,
  day: string,
  hour: string,
  minute: string,
) => {
  if (!time) return "";

  const dateUnix = unixFromDateTime(time);
  const now = Math.floor(Date.now() / 1000);
  const diffSeconds = now - dateUnix;

  if (diffSeconds < 0) return "";

  const startDate = new Date(dateUnix * 1000);
  const endDate = new Date(now * 1000);

  let years = endDate.getFullYear() - startDate.getFullYear();
  let months = endDate.getMonth() - startDate.getMonth();
  let days = endDate.getDate() - startDate.getDate();
  let hours = endDate.getHours() - startDate.getHours();
  let minutes = endDate.getMinutes() - startDate.getMinutes();

  if (minutes < 0) {
    minutes += 60;
    hours -= 1;
  }

  if (hours < 0) {
    hours += 24;
    days -= 1;
  }

  if (days < 0) {
    const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
    days += prevMonth.getDate();
    months -= 1;
  }

  if (months < 0) {
    months += 12;
    years -= 1;
  }

  const parts = [];

  if (years > 0) {
    parts.push(`${years}${year}.`);
  }

  if (months > 0 || years > 0) {
    parts.push(`${months}${month}.`);
  }

  if (days > 0 || months > 0 || years > 0) {
    parts.push(`${days}${day}.`);
  }

  if (hours > 0 || days > 0 || months > 0 || years > 0) {
    parts.push(`${hours}${hour}.`);
  }

  if (minutes > 0 || (years === 0 && months === 0 && days === 0 && hours === 0)) {
    parts.push(`${minutes}${minute}.`);
  }

  if (parts.length === 0) {
    return `0${minute}.`;
  }

  return parts.join(" ");
};
